import { render } from "./main.area.vue?vue&type=template&id=4455016e&scoped=true"
import script from "./main.area.vue?vue&type=script&lang=js"
export * from "./main.area.vue?vue&type=script&lang=js"

import "./main.area.vue?vue&type=style&index=0&id=4455016e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4455016e"]])

export default __exports__